import { render, staticRenderFns } from "./CommunicationHistory.vue?vue&type=template&id=c037cb1e&scoped=true"
import script from "./CommunicationHistory.vue?vue&type=script&lang=js"
export * from "./CommunicationHistory.vue?vue&type=script&lang=js"
import style0 from "./CommunicationHistory.vue?vue&type=style&index=0&id=c037cb1e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c037cb1e",
  null
  
)

export default component.exports